'use client';

import { useEffect, useState } from 'react';

type PublicLearnLoadingGateProps = {
  children: React.ReactNode;
};

export default function PublicLearnLoadingGate({ children }: PublicLearnLoadingGateProps) {
  const [hydrated, setHydrated] = useState(false);

  useEffect(() => {
    setHydrated(true);
  }, []);

  if (hydrated) {
    return null;
  }

  return <>{children}</>;
}
